import React from 'react';
import { Outlet, useNavigate } from 'react-router-dom';
import { AppNavigation } from './AppNavigation';
import { RouterProvider } from 'react-aria-components';

export function AppLayout() {
	const navigate = useNavigate();
	return (
		<RouterProvider navigate={navigate}>
			<div className="flex h-svh flex-col bg-gray-100">
				<AppNavigation />
				<Outlet />
			</div>
		</RouterProvider>
	);
}
